import { render, staticRenderFns } from "./LiveBroker.vue?vue&type=template&id=b055e610&scoped=true"
import script from "./LiveBroker.vue?vue&type=script&lang=js"
export * from "./LiveBroker.vue?vue&type=script&lang=js"
import style0 from "./LiveBroker.vue?vue&type=style&index=0&id=b055e610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b055e610",
  null
  
)

export default component.exports